/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* GRL_MODIFY: Modified from codegen version. GRL_MODIFY marks changes
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  SelectField,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { Impacts } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ImpactsCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    presets, // GRL_MODIFY: add presets prop
    ...rest
  } = props;
  const initialValues = {
    Name: "",
    ImpactType: "",
    ImpactDescription: "",
    CurrentFinancialImpactLower: "",
    CurrentFinancialImpactHigher: "",
    WhyNoCurrentQuantitativeInformation: "",
    AnticipatedImpactDescription: "",
    AnticipatedFinancialImpactLower: "",
    AnticipatedFinancialImpactHigher: "",
    TimeHorizon: "",
    WhyNoFutureQuantitativeInformation: "",
    ...presets // GRL_MODIFY: add presets to initial values
  };
  const [Name, setName] = React.useState(initialValues.Name);
  const [ImpactType, setImpactType] = React.useState(initialValues.ImpactType);
  const [ImpactDescription, setImpactDescription] = React.useState(
    initialValues.ImpactDescription
  );
  const [CurrentFinancialImpactLower, setCurrentFinancialImpactLower] =
    React.useState(initialValues.CurrentFinancialImpactLower);
  const [CurrentFinancialImpactHigher, setCurrentFinancialImpactHigher] =
    React.useState(initialValues.CurrentFinancialImpactHigher);
  const [
    WhyNoCurrentQuantitativeInformation,
    setWhyNoCurrentQuantitativeInformation,
  ] = React.useState(initialValues.WhyNoCurrentQuantitativeInformation);
  const [AnticipatedImpactDescription, setAnticipatedImpactDescription] =
    React.useState(initialValues.AnticipatedImpactDescription);
  const [AnticipatedFinancialImpactLower, setAnticipatedFinancialImpactLower] =
    React.useState(initialValues.AnticipatedFinancialImpactLower);
  const [
    AnticipatedFinancialImpactHigher,
    setAnticipatedFinancialImpactHigher,
  ] = React.useState(initialValues.AnticipatedFinancialImpactHigher);
  const [TimeHorizon, setTimeHorizon] = React.useState(
    initialValues.TimeHorizon
  );
  const [
    WhyNoFutureQuantitativeInformation,
    setWhyNoFutureQuantitativeInformation,
  ] = React.useState(initialValues.WhyNoFutureQuantitativeInformation);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setName(initialValues.Name);
    setImpactType(initialValues.ImpactType);
    setImpactDescription(initialValues.ImpactDescription);
    setCurrentFinancialImpactLower(initialValues.CurrentFinancialImpactLower);
    setCurrentFinancialImpactHigher(initialValues.CurrentFinancialImpactHigher);
    setWhyNoCurrentQuantitativeInformation(
      initialValues.WhyNoCurrentQuantitativeInformation
    );
    setAnticipatedImpactDescription(initialValues.AnticipatedImpactDescription);
    setAnticipatedFinancialImpactLower(
      initialValues.AnticipatedFinancialImpactLower
    );
    setAnticipatedFinancialImpactHigher(
      initialValues.AnticipatedFinancialImpactHigher
    );
    setTimeHorizon(initialValues.TimeHorizon);
    setWhyNoFutureQuantitativeInformation(
      initialValues.WhyNoFutureQuantitativeInformation
    );
    setErrors({});
  };
  const validations = {
    Name: [],
    ImpactType: [],
    ImpactDescription: [],
    CurrentFinancialImpactLower: [],
    CurrentFinancialImpactHigher: [],
    WhyNoCurrentQuantitativeInformation: [],
    AnticipatedImpactDescription: [],
    AnticipatedFinancialImpactLower: [],
    AnticipatedFinancialImpactHigher: [],
    TimeHorizon: [],
    WhyNoFutureQuantitativeInformation: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          Name,
          ImpactType,
          ImpactDescription,
          CurrentFinancialImpactLower,
          CurrentFinancialImpactHigher,
          WhyNoCurrentQuantitativeInformation,
          AnticipatedImpactDescription,
          AnticipatedFinancialImpactLower,
          AnticipatedFinancialImpactHigher,
          TimeHorizon,
          WhyNoFutureQuantitativeInformation,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new Impacts(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "ImpactsCreateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Climate Related Impact"
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 12 a-c,15 a-d."
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Text
        children="Create a record that describes an impact you have identified, and link it to the relevant Risk or Opportunity that gives rise to this impact."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <Heading
        children="NZCS1 paragraph 12 a-c"
        {...getOverrideProps(overrides, "SectionalElement00")}
      ></Heading>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid5")}
      >
        <TextField
          label="Impact name"
          isRequired={false}
          isReadOnly={false}
          value={Name}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                Name: value,
                ImpactType,
                ImpactDescription,
                CurrentFinancialImpactLower,
                CurrentFinancialImpactHigher,
                WhyNoCurrentQuantitativeInformation,
                AnticipatedImpactDescription,
                AnticipatedFinancialImpactLower,
                AnticipatedFinancialImpactHigher,
                TimeHorizon,
                WhyNoFutureQuantitativeInformation,
              };
              const result = onChange(modelFields);
              value = result?.Name ?? value;
            }
            if (errors.Name?.hasError) {
              runValidationTasks("Name", value);
            }
            setName(value);
          }}
          onBlur={() => runValidationTasks("Name", Name)}
          errorMessage={errors.Name?.errorMessage}
          hasError={errors.Name?.hasError}
          {...getOverrideProps(overrides, "Name")}
        ></TextField>
        <SelectField
          label="Impact type"
          placeholder="Please select an option"
          isDisabled={false}
          value={ImpactType}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                Name,
                ImpactType: value,
                ImpactDescription,
                CurrentFinancialImpactLower,
                CurrentFinancialImpactHigher,
                WhyNoCurrentQuantitativeInformation,
                AnticipatedImpactDescription,
                AnticipatedFinancialImpactLower,
                AnticipatedFinancialImpactHigher,
                TimeHorizon,
                WhyNoFutureQuantitativeInformation,
              };
              const result = onChange(modelFields);
              value = result?.ImpactType ?? value;
            }
            if (errors.ImpactType?.hasError) {
              runValidationTasks("ImpactType", value);
            }
            setImpactType(value);
          }}
          onBlur={() => runValidationTasks("ImpactType", ImpactType)}
          errorMessage={errors.ImpactType?.errorMessage}
          hasError={errors.ImpactType?.hasError}
          {...getOverrideProps(overrides, "ImpactType")}
        >
          <option
            children="Acute physical"
            value="Acute_Physical"
            {...getOverrideProps(overrides, "ImpactTypeoption0")}
          ></option>
          <option
            children="Chronic physical"
            value="Chronic_Physical"
            {...getOverrideProps(overrides, "ImpactTypeoption1")}
          ></option>
          <option
            children="Market"
            value="Market"
            {...getOverrideProps(overrides, "ImpactTypeoption2")}
          ></option>
          <option
            children="Physical"
            value="Physical"
            {...getOverrideProps(overrides, "ImpactTypeoption3")}
          ></option>
          <option
            children="Policy and legal"
            value="Policy_and_Legal"
            {...getOverrideProps(overrides, "ImpactTypeoption4")}
          ></option>
          <option
            children="Reputation"
            value="Reputation"
            {...getOverrideProps(overrides, "ImpactTypeoption5")}
          ></option>
          <option
            children="Technology"
            value="Technology"
            {...getOverrideProps(overrides, "ImpactTypeoption6")}
          ></option>
          <option
            children="Transition"
            value="Transition"
            {...getOverrideProps(overrides, "ImpactTypeoption7")}
          ></option>
        </SelectField>
      </Grid>
      <TextAreaField
        label="Current impact description"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name,
              ImpactType,
              ImpactDescription: value,
              CurrentFinancialImpactLower,
              CurrentFinancialImpactHigher,
              WhyNoCurrentQuantitativeInformation,
              AnticipatedImpactDescription,
              AnticipatedFinancialImpactLower,
              AnticipatedFinancialImpactHigher,
              TimeHorizon,
              WhyNoFutureQuantitativeInformation,
            };
            const result = onChange(modelFields);
            value = result?.ImpactDescription ?? value;
          }
          if (errors.ImpactDescription?.hasError) {
            runValidationTasks("ImpactDescription", value);
          }
          setImpactDescription(value);
        }}
        onBlur={() =>
          runValidationTasks("ImpactDescription", ImpactDescription)
        }
        errorMessage={errors.ImpactDescription?.errorMessage}
        hasError={errors.ImpactDescription?.hasError}
        	value={ImpactDescription} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "ImpactDescription")}
      ></TextAreaField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid7")}
      >
        <TextField
          label="Current financial impact (lower $ value)"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={CurrentFinancialImpactLower}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                Name,
                ImpactType,
                ImpactDescription,
                CurrentFinancialImpactLower: value,
                CurrentFinancialImpactHigher,
                WhyNoCurrentQuantitativeInformation,
                AnticipatedImpactDescription,
                AnticipatedFinancialImpactLower,
                AnticipatedFinancialImpactHigher,
                TimeHorizon,
                WhyNoFutureQuantitativeInformation,
              };
              const result = onChange(modelFields);
              value = result?.CurrentFinancialImpactLower ?? value;
            }
            if (errors.CurrentFinancialImpactLower?.hasError) {
              runValidationTasks("CurrentFinancialImpactLower", value);
            }
            setCurrentFinancialImpactLower(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "CurrentFinancialImpactLower",
              CurrentFinancialImpactLower
            )
          }
          errorMessage={errors.CurrentFinancialImpactLower?.errorMessage}
          hasError={errors.CurrentFinancialImpactLower?.hasError}
          {...getOverrideProps(overrides, "CurrentFinancialImpactLower")}
        ></TextField>
        <TextField
          label="Current financial impact (higher $ value)"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={CurrentFinancialImpactHigher}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                Name,
                ImpactType,
                ImpactDescription,
                CurrentFinancialImpactLower,
                CurrentFinancialImpactHigher: value,
                WhyNoCurrentQuantitativeInformation,
                AnticipatedImpactDescription,
                AnticipatedFinancialImpactLower,
                AnticipatedFinancialImpactHigher,
                TimeHorizon,
                WhyNoFutureQuantitativeInformation,
              };
              const result = onChange(modelFields);
              value = result?.CurrentFinancialImpactHigher ?? value;
            }
            if (errors.CurrentFinancialImpactHigher?.hasError) {
              runValidationTasks("CurrentFinancialImpactHigher", value);
            }
            setCurrentFinancialImpactHigher(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "CurrentFinancialImpactHigher",
              CurrentFinancialImpactHigher
            )
          }
          errorMessage={errors.CurrentFinancialImpactHigher?.errorMessage}
          hasError={errors.CurrentFinancialImpactHigher?.hasError}
          {...getOverrideProps(overrides, "CurrentFinancialImpactHigher")}
        ></TextField>
      </Grid>
      <TextAreaField
        label="Provide an explanation if you cannot disclose current quantitative information for this impact"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name,
              ImpactType,
              ImpactDescription,
              CurrentFinancialImpactLower,
              CurrentFinancialImpactHigher,
              WhyNoCurrentQuantitativeInformation: value,
              AnticipatedImpactDescription,
              AnticipatedFinancialImpactLower,
              AnticipatedFinancialImpactHigher,
              TimeHorizon,
              WhyNoFutureQuantitativeInformation,
            };
            const result = onChange(modelFields);
            value = result?.WhyNoCurrentQuantitativeInformation ?? value;
          }
          if (errors.WhyNoCurrentQuantitativeInformation?.hasError) {
            runValidationTasks("WhyNoCurrentQuantitativeInformation", value);
          }
          setWhyNoCurrentQuantitativeInformation(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "WhyNoCurrentQuantitativeInformation",
            WhyNoCurrentQuantitativeInformation
          )
        }
        errorMessage={errors.WhyNoCurrentQuantitativeInformation?.errorMessage}
        hasError={errors.WhyNoCurrentQuantitativeInformation?.hasError}
        	value={WhyNoCurrentQuantitativeInformation} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "WhyNoCurrentQuantitativeInformation")}
      ></TextAreaField>
      <Heading
        children="NZCS1 paragraph 15 a-d."
        {...getOverrideProps(overrides, "SectionalElement01")}
      ></Heading>
      <TextAreaField
        label="Anticipated impact description"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name,
              ImpactType,
              ImpactDescription,
              CurrentFinancialImpactLower,
              CurrentFinancialImpactHigher,
              WhyNoCurrentQuantitativeInformation,
              AnticipatedImpactDescription: value,
              AnticipatedFinancialImpactLower,
              AnticipatedFinancialImpactHigher,
              TimeHorizon,
              WhyNoFutureQuantitativeInformation,
            };
            const result = onChange(modelFields);
            value = result?.AnticipatedImpactDescription ?? value;
          }
          if (errors.AnticipatedImpactDescription?.hasError) {
            runValidationTasks("AnticipatedImpactDescription", value);
          }
          setAnticipatedImpactDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "AnticipatedImpactDescription",
            AnticipatedImpactDescription
          )
        }
        errorMessage={errors.AnticipatedImpactDescription?.errorMessage}
        hasError={errors.AnticipatedImpactDescription?.hasError}
        	value={AnticipatedImpactDescription} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "AnticipatedImpactDescription")}
      ></TextAreaField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid11")}
      >
        <TextField
          label="Anticipated financial impact (lower $ value)"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={AnticipatedFinancialImpactLower}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                Name,
                ImpactType,
                ImpactDescription,
                CurrentFinancialImpactLower,
                CurrentFinancialImpactHigher,
                WhyNoCurrentQuantitativeInformation,
                AnticipatedImpactDescription,
                AnticipatedFinancialImpactLower: value,
                AnticipatedFinancialImpactHigher,
                TimeHorizon,
                WhyNoFutureQuantitativeInformation,
              };
              const result = onChange(modelFields);
              value = result?.AnticipatedFinancialImpactLower ?? value;
            }
            if (errors.AnticipatedFinancialImpactLower?.hasError) {
              runValidationTasks("AnticipatedFinancialImpactLower", value);
            }
            setAnticipatedFinancialImpactLower(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "AnticipatedFinancialImpactLower",
              AnticipatedFinancialImpactLower
            )
          }
          errorMessage={errors.AnticipatedFinancialImpactLower?.errorMessage}
          hasError={errors.AnticipatedFinancialImpactLower?.hasError}
          {...getOverrideProps(overrides, "AnticipatedFinancialImpactLower")}
        ></TextField>
        <TextField
          label="Anticipated financial impact (higher $ value)"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={AnticipatedFinancialImpactHigher}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                Name,
                ImpactType,
                ImpactDescription,
                CurrentFinancialImpactLower,
                CurrentFinancialImpactHigher,
                WhyNoCurrentQuantitativeInformation,
                AnticipatedImpactDescription,
                AnticipatedFinancialImpactLower,
                AnticipatedFinancialImpactHigher: value,
                TimeHorizon,
                WhyNoFutureQuantitativeInformation,
              };
              const result = onChange(modelFields);
              value = result?.AnticipatedFinancialImpactHigher ?? value;
            }
            if (errors.AnticipatedFinancialImpactHigher?.hasError) {
              runValidationTasks("AnticipatedFinancialImpactHigher", value);
            }
            setAnticipatedFinancialImpactHigher(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "AnticipatedFinancialImpactHigher",
              AnticipatedFinancialImpactHigher
            )
          }
          errorMessage={errors.AnticipatedFinancialImpactHigher?.errorMessage}
          hasError={errors.AnticipatedFinancialImpactHigher?.hasError}
          {...getOverrideProps(overrides, "AnticipatedFinancialImpactHigher")}
        ></TextField>
      </Grid>
      <SelectField
        label="Time horizon"
        placeholder="Please select an option"
        isDisabled={false}
        value={TimeHorizon}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name,
              ImpactType,
              ImpactDescription,
              CurrentFinancialImpactLower,
              CurrentFinancialImpactHigher,
              WhyNoCurrentQuantitativeInformation,
              AnticipatedImpactDescription,
              AnticipatedFinancialImpactLower,
              AnticipatedFinancialImpactHigher,
              TimeHorizon: value,
              WhyNoFutureQuantitativeInformation,
            };
            const result = onChange(modelFields);
            value = result?.TimeHorizon ?? value;
          }
          if (errors.TimeHorizon?.hasError) {
            runValidationTasks("TimeHorizon", value);
          }
          setTimeHorizon(value);
        }}
        onBlur={() => runValidationTasks("TimeHorizon", TimeHorizon)}
        errorMessage={errors.TimeHorizon?.errorMessage}
        hasError={errors.TimeHorizon?.hasError}
        {...getOverrideProps(overrides, "TimeHorizon")}
      >
        <option
          children="Current"
          value="Current"
          {...getOverrideProps(overrides, "TimeHorizonoption0")}
        ></option>
        <option
          children="Short term"
          value="Short_Term"
          {...getOverrideProps(overrides, "TimeHorizonoption1")}
        ></option>
        <option
          children="Medium term"
          value="Medium_Term"
          {...getOverrideProps(overrides, "TimeHorizonoption2")}
        ></option>
        <option
          children="Long term"
          value="Long_Term"
          {...getOverrideProps(overrides, "TimeHorizonoption3")}
        ></option>
        <option
          children="All climate planning horizons"
          value="All_Climate_Planning_Horizons"
          {...getOverrideProps(overrides, "TimeHorizonoption4")}
        ></option>
      </SelectField>
      <TextAreaField
        label="Provide an explanation if you cannot disclose future quantitative information for this impact"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name,
              ImpactType,
              ImpactDescription,
              CurrentFinancialImpactLower,
              CurrentFinancialImpactHigher,
              WhyNoCurrentQuantitativeInformation,
              AnticipatedImpactDescription,
              AnticipatedFinancialImpactLower,
              AnticipatedFinancialImpactHigher,
              TimeHorizon,
              WhyNoFutureQuantitativeInformation: value,
            };
            const result = onChange(modelFields);
            value = result?.WhyNoFutureQuantitativeInformation ?? value;
          }
          if (errors.WhyNoFutureQuantitativeInformation?.hasError) {
            runValidationTasks("WhyNoFutureQuantitativeInformation", value);
          }
          setWhyNoFutureQuantitativeInformation(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "WhyNoFutureQuantitativeInformation",
            WhyNoFutureQuantitativeInformation
          )
        }
        errorMessage={errors.WhyNoFutureQuantitativeInformation?.errorMessage}
        hasError={errors.WhyNoFutureQuantitativeInformation?.hasError}
        	value={WhyNoFutureQuantitativeInformation} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "WhyNoFutureQuantitativeInformation")}
      ></TextAreaField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
